module.exports = __webpack_public_path__ + "static/phone.1b3fe215.png";